// Datos de prueba (MOCK) para que el dashboard sea demostrable
// Ajusta shapes para que coincidan con tu API real cuando lo conectes.

function rand(min, max){ return Math.floor(Math.random()*(max-min+1))+min; }
function fdate(d){
  const y = d.getFullYear();
  const m = String(d.getMonth()+1).padStart(2,"0");
  const dd = String(d.getDate()).padStart(2,"0");
  return `${y}-${m}-${dd}`;
}

export function mockBranches(){
  return [
    { id: "", nombre: "Todas las sucursales" },
    { id: "001", nombre: "Sucursal 001 - Centro" },
    { id: "002", nombre: "Sucursal 002 - Norte" },
    { id: "003", nombre: "Sucursal 003 - Sur" }
  ];
}

export function mockSalesSummary({from, to}){
  // KPIs
  return {
    totalVentas: rand(1200, 9000),
    pedidos: rand(180, 1200),
    ticketPromedio: rand(7, 18) + (rand(0,99)/100),
    clientesNuevos: rand(10, 120),
    cancelaciones: rand(0, 40),
    devoluciones: rand(0, 25)
  };
}

export function mockSalesByHour(){
  // 0..23
  const labels = Array.from({length:24}, (_,i)=>String(i).padStart(2,"0")+":00");
  const values = labels.map(()=>rand(0, 120));
  return { labels, values };
}

export function mockSalesByDay({from, to}){
  const start = new Date(from+"T00:00:00");
  const end = new Date(to+"T00:00:00");
  const labels = [];
  const values = [];
  for(let d=new Date(start); d<=end; d.setDate(d.getDate()+1)){
    labels.push(fdate(new Date(d)));
    values.push(rand(50, 600));
  }
  return { labels, values };
}

export function mockProductsRanking(){
  const items = [
    "Hamburguesa Clásica","Papas Medianas","Gaseosa 500ml","Alitas x8",
    "Pizza Personal","Ensalada","Combo Familiar","Postre","Café","Wrap"
  ];
  const rows = items.map((name, idx)=>({
    id: idx+1,
    producto: name,
    categoria: ["Comida","Bebidas","Combos","Postres"][rand(0,3)],
    cantidad: rand(10, 500),
    ingreso: rand(50, 2500) + (rand(0,99)/100)
  }));
  // participación %
  const total = rows.reduce((a,r)=>a+r.ingreso,0) || 1;
  rows.forEach(r=>{ r.participacion = +( (r.ingreso/total)*100 ).toFixed(2); });
  // marcar baja rotación
  rows.forEach(r=>{
    r.bajaRotacion = r.cantidad < 40;
    r.extremo = r.cantidad > 350;
  });
  // ordenar por ingreso desc
  rows.sort((a,b)=>b.ingreso-a.ingreso);
  return rows;
}

export function mockCustomersStats(){
  return {
    frecuentes: rand(40, 320),
    nuevos: rand(10, 150),
    creadosSinVentas: rand(0, 60),
    topFrecuentes: Array.from({length:10}, (_,i)=>({
      id: i+1,
      cliente: `Cliente ${i+1}`,
      pedidos: rand(3, 22),
      gasto: rand(20, 350) + (rand(0,99)/100),
      ultimaCompra: `2026-01-${String(rand(1,27)).padStart(2,"0")}`
    }))
  };
}

export function mockOrdersByCustomer(){
  // ejemplo de historial resumido
  return Array.from({length:12}, (_,i)=>({
    id: i+1,
    cliente: `Cliente ${rand(1,50)}`,
    pedidos: rand(1, 18),
    frecuenciaDias: rand(3, 40),
    preferencia: ["Delivery","Retiro","Mesa"][rand(0,2)],
    ticketProm: rand(6, 20) + (rand(0,99)/100)
  }));
}

export function mockAvgTicket(){
  return {
    ticketPromedio: rand(7, 18) + (rand(0,99)/100),
    serie: Array.from({length:10}, (_,i)=>({
      label: `Semana ${i+1}`,
      value: rand(6, 19) + (rand(0,99)/100)
    }))
  };
}

export function mockCancellations(){
  return {
    resumen: {
      cancelaciones: rand(0, 40),
      devoluciones: rand(0, 25),
      cambiosSucursal: rand(0, 15)
    },
    detalle: Array.from({length:14}, (_,i)=>({
      id: i+1,
      fecha: `2026-01-${String(rand(1,27)).padStart(2,"0")}`,
      sucursalOrigen: ["001","002","003"][rand(0,2)],
      sucursalDestino: ["001","002","003"][rand(0,2)],
      tipo: ["CANCELACIÓN","DEVOLUCIÓN","CAMBIO SUCURSAL"][rand(0,2)],
      monto: rand(3, 60) + (rand(0,99)/100),
      motivo: ["Cliente desistió","Error de dirección","Sin stock","Tiempo de entrega"][rand(0,3)]
    }))
  };
}

export function mockHeatmap(){
  // Heatmap: días (L-D) x horas (10..22)
  const days = ["Lun","Mar","Mié","Jue","Vie","Sáb","Dom"];
  const hours = Array.from({length:13}, (_,i)=>10+i); // 10..22
  const matrix = days.map(()=>hours.map(()=>rand(0, 60)));
  return { days, hours, matrix };
}
